import React, { useCallback, useEffect } from 'react';
import styles from './MyMembers.module.css';
import { CustomButton, CustomList, CustomLoader, CustomTitle } from '../../../components';
import { useTranslation } from 'react-i18next';
import { getUsersList } from '../../../services/userService';
import { addMembers, getMembers, removeMemberById } from '../../../services/subusersLinkService';
import CustomAutocomplete from '../../../components/customAutocomplete/CustomAutocomplete';
import { userTypes } from '../../../enums/userTypes.enum';
import { RootState } from '../../../store/store';
import { useSelector } from 'react-redux';

const MyMembers = () => {

    const { t } = useTranslation();
    const userId : number = useSelector((state: RootState) => state.auth.userId);
    
    const [isLoading, setIsLoading] = React.useState(true);
    const [membersList, setMembersList] = React.useState<ListElementType[]>([]);
    const [selectedMembers, setSelectedMembers] = React.useState<ListElementType[]>([]);

    const handleGetMembers = useCallback(async () => {
        setIsLoading(true);
        
        const membersList = await getMembers(userId);
        const formatedList = membersList.map((item: any) => {
            const el: ListElementType = {
                id : item.id,
                title : item.username,
                description : ''
            }

            return el;
        });
        setMembersList(formatedList);

        setIsLoading(false);
    }, [userId]);

    useEffect(() => {
        handleGetMembers();
    }, [handleGetMembers]);

    const handleSearchUser = async (searchText: string) => {

        const usersList = await getUsersList(searchText, userTypes.DV);

        const formatedList = usersList.map((item: any) => {
            const el: ListElementType = {
                id : item.documentId,
                title : item.username,
                description : '',
                isDisabled: membersList.some(member => member.id === item.id)
            }

            return el;
        });

        return formatedList;
    }

    const handleAddMembers = async () => {
        setIsLoading(true);

        const usersToAdd = selectedMembers.map((member: ListElementType) => member.id);
        
        await addMembers(userId, usersToAdd);
        await handleGetMembers();
        
        setSelectedMembers([]);
        setIsLoading(false);
    }

    const handleRemoveMember = async (id: number) => {
        setIsLoading(true);

        await removeMemberById(userId, id);
        await handleGetMembers();
    }

    return (
        <div className={styles.container}>
            { !isLoading &&
                <>
                    <CustomTitle className={styles.title}>{t('account.my_members.title')}</CustomTitle>

                    <div className={styles.addMemberContainer}>
                        <CustomAutocomplete
                            label={t('account.my_members.add_member')}
                            searchFunction={handleSearchUser}
                            values={selectedMembers}
                            changeValues={(value) => setSelectedMembers(value)}
                            sx={{ width: '100%', marginRight: '16px' }}
                        />
                        <CustomButton 
                            onClick={() => handleAddMembers()}
                            disabled={selectedMembers.length === 0}
                        >
                            { t('general.add') }
                        </CustomButton>
                    </div>

                    <div>
                        <CustomList
                            list={membersList}
                            onDeleteBtn={(item: any) => handleRemoveMember(item.id)}
                        />
                    </div>
                </>
            }

            <CustomLoader isLoading={isLoading} loaderType='skeleton' />
        </div>
    )
}

export default MyMembers;